import { useState } from 'react';
import { supabase } from '../../../shared/services/supabase';
import { Customer } from '../../../shared/types';

export const useCustomerUpdate = () => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateCustomer = async (customerId: string, updates: Partial<Customer>) => {
    setIsUpdating(true);
    setError(null);

    try {
      // Entferne undefined Werte
      const cleanedUpdates = Object.entries(updates).reduce((acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {} as Record<string, any>);

      // Update customer in Supabase
      const { error: updateError } = await supabase
        .from('customers')
        .update({
          ...cleanedUpdates,
          updated_at: new Date().toISOString()
        })
        .eq('id', customerId);

      if (updateError) {
        throw updateError;
      }

      console.log(`Kunde ${customerId} erfolgreich aktualisiert`);
    } catch (err) {
      console.error('Error updating customer:', err);
      setError(err instanceof Error ? err.message : 'Unbekannter Fehler beim Aktualisieren');
      throw err;
    } finally {
      setIsUpdating(false);
    }
  };

  return {
    updateCustomer,
    isUpdating,
    error
  };
};